import { clsx } from 'clsx'
import { type FC } from 'react'

import { useProductPageRebrushStyle } from '../../product-page-context/useProductPageRebrushStyle'
import { useProductPageContext } from '../../productPageContext'
import { useProductPrices } from '../hooks/useProductPrices'
import { ProductBuyBoxPrescriptionBonusBadge } from '../ProductBuyBoxPrescriptionBonusBadge/ProductBuyBoxPrescriptionBonusBadge'

import { ProductPageVariantDetails } from './ProductPageVariantDetails'
import { ProductPageVariantQuantityAndUnitPrice } from './ProductPageVariantQuantityAndUnitPrice'

export const ProductPageSingleAttributesHeader: FC = () => {
  const { currentPrescriptionType, currentVariant, offerId } =
    useProductPageContext()
  const {
    formattedUnitPrice,
    isProductNotInCatalog,
    isProductOutOfSale,
    isProductOutOfStock,
  } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product: currentVariant,
  })
  const isRebrushStyle = useProductPageRebrushStyle()

  const isProductNotAvailable =
    isProductNotInCatalog || isProductOutOfStock || isProductOutOfSale

  return (
    <>
      <ProductBuyBoxPrescriptionBonusBadge />
      <div
        className={clsx(
          'flex min-h-[5.5rem] items-center',
          !isRebrushStyle && 'border-b border-b-dark-primary-min',
          isRebrushStyle &&
            'rounded-2xl border border-dark-primary-strong bg-light-primary-low p-2 mobile:p-3.5 desktop:min-h-20',
        )}
      >
        <ProductPageVariantQuantityAndUnitPrice
          className="mr-9 mobile-md:mr-11"
          formattedUnitPrice={formattedUnitPrice}
          isProductNotAvailable={isProductNotAvailable}
          isProductOutOfSale={isProductOutOfSale}
          quantity={
            currentVariant.package_size
              ? `${currentVariant.package_size.quantity} ${currentVariant.package_size.unit}`
              : ''
          }
        />
        <ProductPageVariantDetails candidateVariant={currentVariant} />
      </div>
    </>
  )
}
